import { createRequest, HttpMethod } from 'ehs-react';
import type { at } from '../generated/Beans';

type AccessInformation = at.sense.portlets.saf.checkaccess.beans.ui.AccessInformation;
type VerifyAccessResponse = at.sense.portlets.saf.checkaccess.beans.ui.VerifyAccessResponse;

export const checkAccess = createRequest<
  {
    accessInformation: AccessInformation;
  },
  VerifyAccessResponse
>({
  operation: 'verifyAccessInformation',
  method: HttpMethod.POST
});
